export const PAGE_SIZE_QUERY_PARAM_NAME = 'pageSize';
export const DEFAULT_PAGE_SIZE = 10;
